// extracted by mini-css-extract-plugin
export default {"footercss":"Footer_footercss__IRJMI","text":"Footer_text__X6j6W"};